import { gql } from '@apollo/client'
import { activeDraftFragment } from '~/graphql/fragments/activeDraft'

export const CREATE_DRAFT = gql`
  mutation CreateDraft {
    createDraft {
      draft {
        ...activeDraft
      }
      errors {
        code
        message
      }
    }
  }

  ${activeDraftFragment}
`
